import { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
} from "reactstrap";
import CardsHeader from "components/Headers/CardsHeader.js";
import { dashboardService } from "services";
import LoaderBox from "../components/custom/loader/loaderBox";

const colors = {
  gray: {
    100: "#f6f9fc",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#8898aa",
    700: "#525f7f",
    800: "#172430",
    900: "#212529",
  },
  theme: {
    default: "#172430",
    primary: "#C2641A",
    secondary: "#f4f5f7",
    info: "#046BD2",
    success: "#61CE70",
    danger: "#D9534F",
    warning: "#fb6340",
  },
};

const ChartCard = ({ title, children, footer }) => (
  <Card className="shadow-sm border-0 h-100 mb-4">
    <CardHeader className="bg-transparent border-0 py-3">
      <Row className="align-items-center">
        <Col>
          <h5 className="h3 mb-0 text-dark font-weight-700">{title}</h5>
        </Col>
      </Row>
    </CardHeader>
    <CardBody className="pt-0">
      <div className="chart" style={{ position: 'relative', height: '350px' }}>
        {children}
      </div>
    </CardBody>
    {footer && (
      <div className="card-footer bg-transparent py-3 border-top">
        {footer}
      </div>
    )}
  </Card>
);

function Dashboard() {
  const [billedOrders, setBilledOrders] = useState(null);
  const [WEOrdersState, setWEOrdersState] = useState([]);
  const [externalData, setExternalData] = useState({ total: 0 });
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true);
        const response = await dashboardService.fetchOverview();
        const resData = response.data;
        setBilledOrders(resData);
        setWEOrdersState(resData.graphic_prevision_week || []);
        setExternalData(resData.graphic_external_services || { total: 0 });
      } catch (error) {
        console.error("Dashboard error:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, []);

  const renderBilledQuantity = () => {
    if (!billedOrders) return null;
    const data = {
      labels: billedOrders.competences || [],
      datasets: [
        {
          data: billedOrders.invoiced_orders || [],
          label: "Faturados",
          backgroundColor: colors.theme.success,
          maxBarThickness: 15,
        },
        {
          data: billedOrders.unvoiced_orders || [],
          label: "Não Faturados",
          backgroundColor: colors.theme.danger,
          maxBarThickness: 15,
        }
      ]
    };
    return (
      <ChartCard 
        title="Quantidade de Pedidos"
        footer={
          <div className="d-flex justify-content-around small font-weight-600">
            <span>Faturados: {billedOrders.total_invoiced}</span>
            <span>Pendentes: {billedOrders.total_unvoiced}</span>
          </div>
        }
      >
        <Bar data={data} options={{ maintainAspectRatio: false }} />
      </ChartCard>
    );
  };

  const renderWEPrevision = () => {
    const weData = {
      labels: WEOrdersState.map(o => o.previsionWeek),
      datasets: [{
        data: WEOrdersState.map(o => o.openValueLocalCurrency),
        backgroundColor: [colors.theme.primary, colors.theme.info, colors.theme.success, colors.theme.warning],
      }]
    };
    return (
      <ChartCard title="Previsão Semanal (WE)">
        {WEOrdersState.length > 0 ? <Pie data={weData} options={{ maintainAspectRatio: false }} /> : <p className="text-center py-5">Sem dados</p>}
      </ChartCard>
    );
  };

  return (
    <div className="content">
      <CardsHeader />
      <Container fluid className="mt--6">
        {loader ? <div className="py-5"><LoaderBox /></div> : (
          <>
            <Row>
              <Col lg="6">{renderBilledQuantity()}</Col>
              <Col lg="6">{renderWEPrevision()}</Col>
            </Row>
            {/* Adicionar mais rows conforme necessário */}
          </>
        )}
      </Container>
    </div>
  );
}

export default Dashboard;
